import styled from "styled-components";

export const ContainerFirmaOrden = styled.div`
  width: 359px;
  height: 600px;
  @media (max-height:700px){
    height: 500px;
  }
`;


export const TopAutorizacionOrden = styled.div`
  width: 100%;
  height: 67px;
  background: var(--color-secondary-gradient);
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  color: var(--color-white);
  display: flex;
  justify-content: center;
  align-items: center;

  h1 {
    font-size: 18px;
    font-weight: 700;
    line-height: 150%;
    margin: 0;
    padding: 0;
    width: 320px;
    text-align: center;
  }
`;


export const BodyAutorizacionOrden = styled.div`
  width: 100%;
  height: calc(100% - 67px);
  padding-top: 50px;
  gap: ${({lessGap}) => (lessGap ? "16px": "40px")};

  @media (max-height:700px){
    height: 500px;
    gap: 10px;
    padding-top: 6px;
  }


  .firma-box {
    width: 300px;
    margin: auto;
  }
  .firma-box-pad{
    width: 300px;
    min-width: 300px;
  }
  .sigCanvas {
    width: 300px;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  button {
    width: 300px;
    height: 42px;
    border-radius: 8px;
    color: var(--color-white);
    font-size: 16px;
    font-weight: 500;
    line-height: 150%;
    background-color: var(--color-primary);
  }

  span {
    font-size: 18px;
    font-weight: 700;
    line-height: 150%;
  }
  .btn-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  h1 {
    font-size: 18px;
    font-weight: 700;
    line-height: 150%;
    margin: 0;
    padding: 0;
    width: 320px;
    text-align: center;
  }
`; 